import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
var _documentTypes = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  RIA: 'ria',
  EXE: 'exe',
  HTML: 'html',
  CSV: 'csv',
  TXT: 'txt',
  EXCEL: 'excel',
  WORD: 'word',
  POWERPOINT: 'powerpoint',
  PDF: 'pdf',
  FILE: 'file'
};
_documentTypes.ALL = _valuesInstanceProperty(_).call(_, _documentTypes);
var documentTypes = _documentTypes;
export default documentTypes;
//# sourceMappingURL=document-types.js.map